const knowledgeAreaParser = data => data.map(({ heading, knowledge_area }) => ({ key: knowledge_area, label: heading }));

export default knowledgeAreaParser;
